module.exports = __webpack_public_path__ + "img/logo@3x.56e9bcd8.png";